import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../Components/Footer';
import NavBar from '../Components/NavBar'
import SeoMeta from '../Components/SeoMeta';
import Subscribe from '../Components/Subscribe';
import Testimonials from '../Components/Testimonial';
import './HomePage.css'
import React, { useState, useEffect, useRef } from 'react'
import HeroSection from '../Components/HeroSection';
import Loading from '../Components/Loading';

function HomePage() {
    
    const [roomsData, setRoomsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showLoading, setShowLoading] = useState(true);
    const [guests, setGuests] = useState({
        adults: 1,
        children: 0,
        rooms: 1
    });
    const [showGuestDropdown, setShowGuestDropdown] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const canonicalUrl = `https://www.nimantrana.co.in${location?.pathname || "/noida"}`;

    const roomOffers = roomsData
        .filter((room) => room && room.roomName && room.discountedPrice)
        .map((room) => ({
            "@type": "Offer",
            "name": room.roomName,
            "price": room.discountedPrice,
            "priceCurrency": "INR",
            "availability": "https://schema.org/InStock"
        }));

    const noidaHotelSchema = {
        "@context": "https://schema.org",
        "@type": "Hotel",
        "name": "Nimantrana Suites Noida",
        "url": canonicalUrl,
        "description": "Book luxury suites in Noida with curated amenities, pool access, and concierge hospitality at Nimantrana.",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Gardenia Gateway, Sector 75",
            "addressLocality": "Noida",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201301",
            "addressCountry": "IN"
        },
        "telephone": "+91-7291999222",
        "image": [
            "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room1.jpg",
            "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room2.jpg",
            "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room3.jpg"
        ],
        "amenityFeature": [
            {"@type": "LocationFeatureSpecification", "name": "Pool", "value": true},
            {"@type": "LocationFeatureSpecification", "name": "Lounge Area", "value": true},
            {"@type": "LocationFeatureSpecification", "name": "Luxury Rooms", "value": true}
        ],
        "makesOffer": roomOffers
    };

    const awsRoomImages = [
        "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room1.jpg",
        "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room2.jpg",
        "https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room3.jpg"
    ];

    const amenitiesData = [
        { id: 1, title: 'Pool', image: 'https://nimantrana-media.s3.ap-south-1.amazonaws.com/amenties1.png' },
        { id: 2, title: 'Lounge Area', image: 'https://nimantrana-media.s3.ap-south-1.amazonaws.com/amenties2.jpg' },
        { id: 3, title: 'Luxury Rooms', image: 'https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room2.jpg' }
    ];

    // Fetch rooms data
    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const response = await fetch('https://backend.nimantrana.co.in/api/rooms');
                const result = await response.json();

                if (result.success) {
                    setRoomsData(result.data);
                }
            } catch (error) {
                console.error('Error Fetching Cities', error)
            } finally {
                setLoading(false);
            }
        }

        fetchRooms();
    }, [])

    // Show loading for 3 seconds minimum
    useEffect(() => {
        const timer = setTimeout(() => {
            console.log('Loading timeout reached - showing homepage');
            setShowLoading(false);
        }, 1000); // Show loading for 3 seconds

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                inputRef.current && !inputRef.current.contains(event.target)) {
                setShowGuestDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setShowGuestDropdown(false);
            }
        };

        document.addEventListener('keydown', handleEscapeKey);
        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    // Handle video loaded callback from HeroSection
    const handleVideoLoaded = () => {
        console.log('Video loaded callback received');
        setShowLoading(false);
    };

    // CONDITIONAL RETURN AFTER ALL HOOKS
    if (showLoading) {
        return <Loading />;
    }

    // ... rest of your functions remain the same
    const handleClick = (path) => {
        navigate(path);
    }

    const handleGuestChange = (type, operation) => {
        setGuests(prev => ({
            ...prev,
            [type]: operation === 'increment' ? prev[type] + 1 : Math.max(type === 'adults' ? 1 : 0, prev[type] - 1)
        }));
    };

    const handleGuestDropdownToggle = (e) => {
        e.stopPropagation();
        setShowGuestDropdown(!showGuestDropdown);
    };

    const handleButtonClick = (e, type, operation) => {
        e.stopPropagation();
        handleGuestChange(type, operation);
    };

    const getGuestText = () => {
        const { adults, children, rooms } = guests;
        return `${adults} adult${adults > 1 ? 's' : ''}, ${children} child${children !== 1 ? 'ren' : ''}, ${rooms} room${rooms > 1 ? 's' : ''}`;
    };

    const isDecrementDisabled = (type) => {
        if (type === 'adults') return guests[type] <= 1;
        return guests[type] <= 0;
    };

    const handlePrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + amenitiesData.length) % amenitiesData.length);
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % amenitiesData.length);
    };

    const getItemClass = (index) => {
        if (index === currentIndex) return 'carousel-item center';
        if (index === (currentIndex - 1 + amenitiesData.length) % amenitiesData.length) return 'carousel-item left';
        if (index === (currentIndex + 1) % amenitiesData.length) return 'carousel-item right';
        return 'carousel-item hidden';
    };

    return (
        <div className='mainContainer'>
            <SeoMeta
                title="Luxury Hotel Suites in Noida | Nimantrana"
                description="Stay at Nimantrana Suites in Noida with spacious rooms, poolside amenities, and concierge hospitality tailored for modern travelers."
                canonical={canonicalUrl}
                keywords="Noida luxury hotel, Nimantrana suites, premium rooms Noida, business travel Noida"
                image="https://nimantrana-media.s3.ap-south-1.amazonaws.com/Room1.jpg"
                structuredData={noidaHotelSchema}
            />
            <HeroSection onVideoLoaded={handleVideoLoaded} />
            <div className='aboutUsContainerMain'>
                <div className='aboutUsContainer'>
                    <div className='aboutUsHeadingContainer'>
                        <p>About Us</p>
                    </div>
                    <div className='aboutUsWelcomeContainer'>
                        <p style={{color:'#DCB15D'}} className='heading'>Welcome to Nimantrana</p>
                        <p className='desc'>From luxurious suites to personalized experience, Nimantrana Hotel is designed to make every guest feel at home. Discover the perfect blend of nature, elegance and warmth.</p>
                    </div>
                    <div className='aboutUsImageContainer'>
                        <div className='imageGrid'>
                            <div className='imageRow topRow'>
                                <div className='imageWrapper imageLeft'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus2.jpg" alt="Modern Architecture" />
                                </div>
                                <div className='imageWrapper imageMiddle middleTop'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus1.jpg" alt="Luxury Hotel" />
                                </div>
                                <div className='imageWrapper imageRight'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus3.jpg" alt="Contemporary Design" />
                                </div>
                            </div>
                            <div className='imageRow bottomRow'>
                                <div className='imageWrapper imageLeft'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/poolView1.jpg" alt="Minimalist Home" />
                                </div>
                                <div className='imageWrapper imageMiddle middleBottom'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg" alt="Resort View" />
                                </div>
                                <div className='imageWrapper imageRight'>
                                    <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus6.jpg" alt="Wooden Architecture" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='amentiesContainer'>
                <div className='amentiesHeadingContainer'>
                    <div className='amenties1'>
                        <p style={{color:'#DCB15D'}} className='amentiesHeading'>Our top-rated and highly visited hotel</p>
                    </div>
                    <div className='amenties1'>
                        <p className='amentiesDesc'>Discover our handpicked selection of the year's finest hotels, curated based on feedback from our delighted visitors</p>
                    </div>
                </div>


                <div className='carouselContainer'>
                    <button className='carousel-btn prev-btn' onClick={handlePrevious}>
                        <span style={{color:'#DCB15D'}}>❮</span>
                    </button>


                    <div className='carousel-wrapper'>
                        {amenitiesData.map((item, index) => (
                            <div key={item.id} className={getItemClass(index)}>
                                <div className='carousel-content'>
                                    <h3 className='carousel-title'>{item.title}</h3>
                                    <div className='carousel-image'>
                                        <img src={item.image} alt={item.title} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                    <button className='carousel-btn next-btn' onClick={handleNext}>
                        <span style={{color:'#DCB15D'}}>❯</span>
                    </button>
                </div>
            </div>


            <div className='allRoomsContainer'>
                <div className='roomsHeadingContainer'>
                    <p>Rooms</p>
                </div>
                <div className='roomsDescContainer'>
                    <p>Step into unparalleled elegance with our Presidential Suite, featuring opulent interiors, a private lounge, and panoramic city views – where luxury meets distinction.</p>
                </div>


                <div className='roomCardsContainer'>
                    {loading ? (
                        <div>Loading rooms...</div>
                    ) : (
                        roomsData.map((room, index) => (
                            <div
                                key={room._id}
                                className='roomCard'
                                style={{ backgroundImage: `url(${awsRoomImages[index % 3]})` }}
                                onClick={()=>handleClick(room.path)}
                            >
                                <div className='cardContent'>
                                    <h3 className='roomTitle'>{room.roomName}</h3>
                                    <div className='roomDetails'>
                                        <p className='roomDesc'>{room.roomDescription}</p>
                                        <div className='priceContainer'>
                                            <div className='originalPrice'>₹{room.roomPrice}</div>
                                            <div className='discountBadge'>{room.roomDiscount}% OFF</div>
                                        </div>
                                        <div style={{color:'#DCB15D'}} className='discountedPrice'>₹{room.discountedPrice}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>


            <div className='quoteContainer'>
                <div className='quoteHeadingContainer'>
                    <p style={{color:'#DCB15D'}}>Where Comfort Reigns</p>
                </div>
                <div className='quoteDescContainer'>
                    <p>Nimantrana invites you to experience a stay crafted for comfort and sophistication.
                        Discover serenity, style, and world-class hospitality in every corner.
                    </p>
                </div>


                <div className='photoLayoutContainer'>
                    <div className='masonryGrid'>
                        <div className='masonryItem textCard'>
                            <div className='textCardContent'>
                                <h3>Connect spaces to elevate your stay.</h3>
                                <div className='connectionStatus'>
                                    <span className='connectionCount'>10/10</span>
                                    <span className='connectionLabel'>reviews</span>
                                </div>
                            </div>
                        </div>


                        <div className='masonryItem imageCard tall'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus1.jpg' alt='Hotel interior' />
                        </div>


                        <div className='masonryItem imageCard short'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus2.jpg' alt='Hotel room' />
                        </div>


                        <div className='masonryItem imageCard short'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg' alt='Hotel amenity' />
                        </div>


                        <div className='masonryItem imageCard tall'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/executive1.jpg' alt='Hotel exterior' />
                        </div>


                        <div className='masonryItem imageCard medium'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/poolView1.jpg' alt='Hotel lobby' />
                        </div>


                        <div className='masonryItem imageCard short'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus3.jpg' alt='Hotel dining' />
                        </div>


                        <div className='masonryItem imageCard tall'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/poolView4.jpg' alt='Hotel spa' />
                        </div>


                        <div className='masonryItem imageCard medium'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/amenties2.jpg' alt='Hotel view' />
                        </div>


                        <div className='masonryItem imageCard short'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/cityView1.jpg' alt='Hotel suite' />
                        </div>


                        <div className='masonryItem imageCard tall'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/cityView3.jpg' alt='Hotel garden' />
                        </div>


                        <div className='masonryItem imageCard medium'>
                            <img src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/poolView3.jpg' alt='Hotel pool' />
                        </div>
                    </div>
                </div>
            </div>


            <Testimonials />
            <Subscribe />
            <Footer />
        </div>
    )
}

export default HomePage;
